import { NgModule, ModuleWithProviders, Injector, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import {
    HexadecimalValueValidator,
    ValidationComponent,
    ButtonComponent,
    InputComponent,
} from './controls';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { MinDirective, MaxDirective } from './controls/base/min.max.directive';
import { MaterialModule } from './material.module';
import { PersianNumberPipe } from 'src/services/persian-number.pipe';
import { CorrectYeKeService } from 'src/services/correctyeke.service';

export let AppInjector: Injector;
const components = [
    HexadecimalValueValidator,
    ValidationComponent,
    MinDirective,
    MaxDirective,
    ButtonComponent,
    InputComponent,
]
const providers = [
    CorrectYeKeService

]
@NgModule({
    declarations: [...components],
    imports: [
        CommonModule,
        FormsModule,
        HttpClientModule,
        MaterialModule,
        TranslateModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ...components,
        MaterialModule,
        TranslateModule,
    ],
    providers: [
        ...providers,
    ]
})
export class ControlsModule {
    constructor(private injector: Injector) {
        AppInjector = this.injector;
    }
    static forRoot(): ModuleWithProviders<ControlsModule> {
        return {
            ngModule: ControlsModule,
            providers: [...providers]
        };
    }
}
